import irelandApi from "../irelandApi";

export const saveEvent = (payload) => (dispatch) => {
  return irelandApi.post("/api/events", { event: payload })
    .then((response) => {
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };

      return Promise.reject(data);
    });
};



// WEBPACK FOOTER //
// ./src/actions/events.js